import styled from 'styled-components';

export const Container = styled.div`
  .form-group {
    text-align: left;
    label {
      font-size: 12px;
      text-transform: uppercase;
      margin-bottom: 2px;
    }
  }
  input[type='submit'].btn.btn-block {
    height: 45px;
    font-size: 14px;
    margin-top: 20px;
    background-color: #28a745;
    &:hover {
      background-color: #32da58;
    }
  }
  #card-wrapper{
    /* &.normal{
      > div.jp-card-container{
        margin: 0;
      }
    } */
    @media (min-width: 1028px) {
      display: none;
    }
    &.left {
      text-align: left;
      @media (min-width: 1028px) {
        position: absolute;
        display: none;
      }
      left: 101%;
      top: 135px;
      margin-bottom: 20px;
    }
`;



// WEBPACK FOOTER //
// ./src/components/CreditCard/style.js